import router from '@/router';
// 进度条
import NProgress from 'nprogress';
// 进度条样式
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

// 注册路由跳转的权限控制
router.beforeEach(async (to, from, next) => {
  let title = '';
  const isCorrect = document.title.includes('远程诊疗中心');
  title = isCorrect ? document.title : '远程诊疗中心';
  // let title = '远程诊疗中心';
  // if (!to.fullPath.startsWith('/demo') && to.fullPath !== '/') {
  //   const isCorrect = document.title.includes('远程诊疗中心');
  //   title = isCorrect ? document.title : '远程诊疗中心';
  // }
  document.title = title;
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});
